<div class="cat-container">

  <!-- Sub-tab group — initially contains only "User VM"; extensible for future cost views -->
  <mat-tab-group animationDuration="150ms" class="cat-sub-tabs">

    <!-- User VM — per-participant VM cost report -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="cat-tab-icon">attach_money</mat-icon>
        User VM
      </ng-template>
      <app-cost-analysis-sub-tab [classId]="classId" [classTitle]="classTitle" [costReport]="vmCostReport"
        [isLoading]="isLoadingVmCostReport" [loadError]="vmCostReportError" (loadRequested)="loadVmCostReport()"
        [exportService]="exportService">
      </app-cost-analysis-sub-tab>
    </mat-tab>

  </mat-tab-group>

</div>